import {
  Save,
  Loader2,
  ArrowLeft,
  ChevronsRight,
  Plus,
  Trash2,
} from "lucide-react";

function FormButton({
  icon: Icon,
  children,
  onClick,
  disabled,
  variant = "primary",
  loading,
  additionalClass,
}) {
  const baseClasses =
    "flex items-center gap-2 px-6 py-2 rounded-lg transition duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary: "bg-blue-600 hover:bg-blue-700 text-white",
    success: "bg-green-600 hover:bg-green-700 text-white",
    secondary: "bg-gray-100 hover:bg-gray-200 text-gray-800",
    purple: "bg-purple-600 hover:bg-purple-700 text-white",
    danger: "bg-red-600 hover:bg-red-700 text-white",
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variants[variant]} ${additionalClass}`}
    >
      {loading ? (
        <Loader2 className="animate-spin w-4 h-4" />
      ) : (
        Icon && <Icon className="w-4 h-4" />
      )}
      {children}
    </button>
  );
}
export default FormButton;
